import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { allWorks } from '@/mocks/pagesData';

export default function ArticlePage() {
  const { id } = useParams();
  const work = allWorks.find((w) => w.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!work) {
    return (
      <>
        <Navbar />
        <main className="pt-20 min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-4">
              <i className="ri-error-warning-line text-3xl text-foreground-300"></i>
            </div>
            <h1 className="text-xl font-heading font-bold text-foreground-950 mb-2">作品未找到</h1>
            <p className="text-sm text-foreground-500 mb-6">该作品不存在或已被下架</p>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              返回作品列表
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-4xl mx-auto px-4 md:px-6 py-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
              <Link to={`/category/${work.categorySlug}`} className="hover:text-primary-500 transition-colors cursor-pointer">{work.category}</Link>
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
              <span className="text-foreground-700 font-medium">{work.title}</span>
            </nav>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 md:px-6 py-8">
          <article>
            <header className="mb-8">
              <div className="flex items-center gap-3 mb-4">
                <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700">
                  {work.category}
                </span>
                <span className="px-3 py-1 rounded-full text-xs font-bold bg-accent-100 text-accent-800">
                  评分 {work.rating}
                </span>
              </div>

              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                {work.title}
              </h1>

              <p className="text-base text-foreground-500 leading-relaxed mb-6">
                {work.description}
              </p>

              <div className="flex flex-wrap items-center gap-5 text-sm text-foreground-600">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
                  <strong className="text-foreground-800">导演：</strong>{work.director}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-group-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
                  <strong className="text-foreground-800">主演：</strong>{work.cast}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
                  <strong className="text-foreground-800">年份：</strong>{work.year}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-film-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
                  <strong className="text-foreground-800">集数：</strong>{work.episodes}集
                </span>
              </div>
            </header>

            <div className="mb-10 rounded-lg overflow-hidden">
              <img
                src={work.image}
                alt={work.title}
                title={`${work.title} - 麻豆传媒${work.category}`}
                className="w-full aspect-video object-cover"
              />
            </div>

            <div className="prose-custom">
              {work.content.split('\n\n').map((paragraph, idx) => (
                <p key={idx} className="text-sm text-foreground-700 leading-relaxed mb-5">
                  {paragraph.trim()}
                </p>
              ))}
            </div>

            <div className="mt-10 pt-8 border-t border-background-200/70">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <Link
                  to={`/category/${work.categorySlug}`}
                  className="flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer font-medium"
                >
                  <i className="ri-arrow-left-line"></i>
                  返回{work.category}列表
                </Link>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-foreground-400">分享：</span>
                  <button className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-all cursor-pointer" aria-label="分享到微博">
                    <i className="ri-weibo-line text-sm"></i>
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-all cursor-pointer" aria-label="分享到微信">
                    <i className="ri-wechat-line text-sm"></i>
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-all cursor-pointer" aria-label="复制链接">
                    <i className="ri-link text-sm"></i>
                  </button>
                </div>
              </div>
            </div>
          </article>

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'Article',
                headline: work.title,
                description: work.description,
                author: {
                  '@type': 'Organization',
                  name: '麻豆传媒',
                },
                publisher: {
                  '@type': 'Organization',
                  name: '麻豆传媒',
                },
                datePublished: `${work.year}-01-01`,
                articleBody: work.content,
              }),
            }}
          />
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: '首页',
                    item: 'https://madoumedia.com/',
                  },
                  {
                    '@type': 'ListItem',
                    position: 2,
                    name: work.category,
                    item: `https://madoumedia.com/category/${work.categorySlug}`,
                  },
                  {
                    '@type': 'ListItem',
                    position: 3,
                    name: work.title,
                  },
                ],
              }),
            }}
          />
        </div>
      </main>
      <Footer />
    </>
  );
}